export interface Settings {
	notifications: Record<NotificationType, boolean>;
	security: {
		biometricLock: boolean;
	};
}

export type NotificationType = 'All' | 'NewPost' | 'PostLike' | 'PostComment' | 'DirectMessage';
